import { Enum } from "enumify";
import _ from "lodash";

import { getRadialBounds } from "./geofence-radial-bounds";
import { INITIAL_RADIUS_M } from "../locations/LocationsState";

const MAX_RADIUS_METERS = 100000;

const round5 = _.partial(_.round, _, 5);

export const getRadialCenter = geofenceData => {
  const [lng, lat] = geofenceData.geometry.coordinates;
  return { lat, lng };
};

export const getPolygonalCenter = geofenceData => {
  const [top, left, bottom, right] = getPolygonalBoundingBox(geofenceData);
  return {
    lat: bottom + (top - bottom) / 2,
    lng: left + (right - left) / 2
  };
};

export const getCenter = geofenceData => {
  return getType(geofenceData).center(geofenceData);
};

export const getRadialBoundingBox = geofenceData => {
  const center = getCenter(geofenceData);
  const { buffer } = geofenceData.properties;
  return getRadialBounds(center.lat, center.lng, buffer);
};

export const getPolygonalBoundingBox = geofenceData => {
  const points = geofenceData.geometry.coordinates[0];
  const lats = points.map(pt => pt[1]);
  const lngs = points.map(pt => pt[0]);
  // top, left, bottom, right
  return [_.max(lats), _.min(lngs), _.min(lats), _.max(lngs)];
};

export const getBoundingBox = geofenceData => {
  return getType(geofenceData).boundingBox(geofenceData);
};

export const isRadialFenceValidForFenceData = geofenceData => {
  try {
    const [lng, lat] = geofenceData.geometry.coordinates;
    const { buffer } = geofenceData.properties;
    return isRadialFenceValid(lat, lng, buffer);
  } catch (err) {
    return false;
  }
};

export const isRadialFenceValid = (lat, lng, radius) => {
  if (!(_.isNumber(lat) && _.isNumber(lng))) {
    return false;
  }
  if (_.isNaN(lat) || _.isNaN(lng) || _.isNaN(radius)) {
    return false;
  }
  if (lat > 90 || lat < -90 || lng > 180 || lng < -180) {
    return false;
  }
  if (!_.isNumber(radius)) {
    return false;
  }
  const result = !!radius && radius > 0 && radius < MAX_RADIUS_METERS;
  return result;
};

export const isPolygonalFenceValid = geofenceData => {
  // TODO
  return true;
};

export const isFenceValid = geofenceData => {
  return getType(geofenceData).isValid(geofenceData);
};

export default class GeofenceType extends Enum {}
GeofenceType.initEnum({
  RADIAL: {
    center: getRadialCenter,
    boundingBox: getRadialBoundingBox,
    isValid: isRadialFenceValidForFenceData,
    toRadial: fence => fence,
    toPolygonal: fence => {
      const [top, left, bottom, right] = getRadialBoundingBox(fence).map(
        round5
      );
      const { lat, lng } = getRadialCenter(fence);
      return {
        geometry: {
          coordinates: [
            [
              [left, top],
              [right, top],
              [right, bottom],
              [left, bottom],
              [left, top]
            ]
          ],
          type: "Polygon"
        },
        properties: {
          buffer: 0,
          center: {
            latitude: lat,
            longitude: lng
          }
        }
      };
    }
  },
  POLYGONAL: {
    center: getPolygonalCenter,
    boundingBox: getPolygonalBoundingBox,
    isValid: isPolygonalFenceValid,
    toRadial: fence => {
      const { latitude, longitude } = fence.properties.center;
      return {
        geometry: {
          coordinates: [longitude, latitude],
          type: "Point"
        },
        properties: {
          buffer: fence.properties.buffer || INITIAL_RADIUS_M
        }
      };
    },
    toPolygonal: fence => fence
  }
});

const geojsonTypeLookup = [
  ["Point", GeofenceType.RADIAL],
  ["Polygon", GeofenceType.POLYGONAL]
];

export const byFeatureType = _.fromPairs(geojsonTypeLookup);
export const byFenceType = _.fromPairs(geojsonTypeLookup.map((k, v) => [v, k]));
export const allowedGeojsonFeatureTypes = geojsonTypeLookup.map(([k, v]) => k);

export const getType = geofenceData => {
  const geojsonType = _.get(geofenceData, "geometry.type");
  if (geojsonType === undefined) {
    throw new Error("Geojson feature has no type");
  }
  const fenceType = _.get(byFeatureType, geojsonType);
  if (fenceType === undefined) {
    throw new TypeError(
      `Geofence feature has unrecognized geojson type '${geojsonType}'`
    );
  }
  return fenceType;
};



// WEBPACK FOOTER //
// ./src/modules/geofence-edit/geofence-types.js